import _ from 'lodash';
import cookie from 'react-cookie';

function refreshIntercom() {
  [200, 300, 400, 500, 1000].forEach(timeout => {
    window.setTimeout(() => {
      if (_.isFunction(window.Intercom)) {
        window.Intercom('update');
      } else {
        window.setTimeout(() => {
          window.Intercom('update');
        }, 1000);
      }
    }, timeout);
  });
}

function eventOnFirstTime(event) {
  const cookieName = 'Event ' + event + 'sent';
  if (cookie.load(cookieName)) {
    return;
  }
  window.analytics.track(event);
  cookie.save(cookieName, true);
  refreshIntercom();
  if (_.isFunction(window.hj)) {
    window.hj('tagRecording', event);
  }
}

function contactSupportWithMessage(message) {
  window.Intercom(
    'showNewMessage', // eslint-disable-line new-cap
    'Hello Crazylister\n' + message + '\n'
  );
}

export {eventOnFirstTime, contactSupportWithMessage, refreshIntercom};
